export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./error.vue?vue&type=template&id=3cf3e0a9&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/error.vue?vue&type=template&id=3cf3e0a9&
// module id = 1236
// module chunks = 0